/**
 * FikoKaplama Dialog — Yüzey İşlem/Kaplama Maliyeti UI
 * İşlem tipi seç → alan/ağırlık × birim fiyat + min ücret. Modelden alan/ağırlık al.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoMassInfo, MALZEMELER } from '../fiko-mass-info/FikoMassInfo';
import { KAPLAMA_TIPLERI, kaplamaHesapla, KaplamaSonuc } from './FikoKaplama';
import { baglamYaz } from '../fiko-uretim-baglam/UretimBaglam';

@Component({
  selector: 'fikoyt-kaplama',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="kp">
    <div class="kp-row">
      <label>İşlem</label>
      <select [(ngModel)]="tipIdx" (ngModelChange)="tipDegisti()">
        @for (t of tipler; track $index) { <option [ngValue]="$index">{{ t.ad }} ({{ t.birim==='kg' ? '₺/kg' : '₺/dm²' }})</option> }
      </select>
    </div>
    <div class="kp-grid">
      <div class="kp-in"><label>Yüzey (dm²)</label><input type="number" [(ngModel)]="alanDm2" (ngModelChange)="hesapla()" min="0" step="0.1"></div>
      <div class="kp-in"><label>Ağırlık (kg)</label><input type="number" [(ngModel)]="agirlikKg" (ngModelChange)="hesapla()" min="0" step="0.1"></div>
      <div class="kp-in"><label>Birim ₺</label><input type="number" [(ngModel)]="fiyat" (ngModelChange)="hesapla()" min="0"></div>
      <div class="kp-in"><label>Min ₺</label><input type="number" [(ngModel)]="min" (ngModelChange)="hesapla()" min="0"></div>
      <div class="kp-in"><label>Adet</label><input type="number" [(ngModel)]="adet" (ngModelChange)="hesapla()" min="1"></div>
    </div>
    <button class="kp-mini" (click)="modeldenAl()">⊕ Modelden Alan/Ağırlık Al</button>

    @if (sonuc) {
      <div class="kp-sonuc">
        <div class="kp-r"><span>Miktar</span><b>{{ f(sonuc.miktar) }} {{ sonuc.birim==='kg' ? 'kg' : 'dm²' }}</b></div>
        <div class="kp-r"><span>Ham maliyet</span><b>{{ f(sonuc.hamMaliyet) }} ₺</b></div>
        @if (sonuc.minUygulandi) { <div class="kp-r min"><span>⚠ Min ücret uygulandı</span><b>{{ f(min) }} ₺</b></div> }
        <div class="kp-r vurgu"><span>Birim maliyet</span><b>{{ f(sonuc.maliyet) }} ₺</b></div>
        <div class="kp-r toplam"><span>TOPLAM ({{ adet }} ad)</span><b>{{ f(sonuc.toplam) }} ₺</b></div>
      </div>
    }
    @if (hata) { <div class="kp-hata">{{ hata }}</div> }
  </div>
  `,
  styles: [`
    .kp { padding:10px; min-width:300px; max-width:340px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .kp-row { display:flex; align-items:center; gap:8px; margin-bottom:8px; }
    .kp-row label { color:#5fd9f5; font-weight:600; }
    .kp-row select { flex:1; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.4); color:#fff; padding:5px; border-radius:4px; }
    .kp-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:5px; margin-bottom:6px; }
    .kp-in { display:flex; flex-direction:column; gap:2px; }
    .kp-in label { font-size:9px; color:#5fd9f5; }
    .kp-in input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; }
    .kp-mini { width:100%; background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:5px; font-size:10px; cursor:pointer; }
    .kp-mini:hover { background:rgba(0,130,160,.8); }
    .kp-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .kp-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .kp-r span { color:#9fe8f7; } .kp-r.min span { color:#ffb36a; } .kp-r.min b { color:#ffb36a; }
    .kp-r.vurgu { background:rgba(0,200,120,.16); margin:4px -8px; padding:6px 8px; border:none; } .kp-r.vurgu b { color:#7dffc0; font-size:13px; }
    .kp-r.toplam { background:rgba(255,180,0,.14); margin:2px -8px -2px; padding:6px 8px; border:none; } .kp-r.toplam b { color:#ffd76a; font-size:13px; }
    .kp-hata { margin-top:8px; padding:6px; background:rgba(255,50,50,.2); border:1px solid rgba(255,100,100,.4); border-radius:4px; color:#ff9a9a; text-align:center; }
  `]
})
export class FikoKaplamaComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() modelleme: any = null;

  tipler = KAPLAMA_TIPLERI;
  tipIdx = 0;
  alanDm2 = 5; agirlikKg = 2; fiyat = 6; min = 60; adet = 1;
  sonuc: KaplamaSonuc | null = null;
  hata: string | null = null;
  private mass = new FikoMassInfo();

  constructor(private cd: ChangeDetectorRef) { this.fiyat = this.tipler[0].fiyat; this.min = this.tipler[0].min; this.sonuc = this.hesaplaInt(); }

  private hesaplaInt(): KaplamaSonuc {
    const t = { ...this.tipler[this.tipIdx], fiyat: this.fiyat, min: this.min };
    return kaplamaHesapla(t, this.alanDm2, this.agirlikKg, this.adet);
  }
  hesapla(): void {
    // tip değişince varsayılan fiyat/min'i çek (kullanıcı elle değiştirmediyse)
    this.sonuc = this.hesaplaInt(); this.cd.detectChanges();
  }
  tipDegisti(): void { this.fiyat = this.tipler[this.tipIdx].fiyat; this.min = this.tipler[this.tipIdx].min; this.hesapla(); }

  modeldenAl(): void {
    const sahne = this.anaGosterim?.sahneler?.[0];
    if (!sahne) { this.hata = 'Sahne yok'; this.cd.detectChanges(); return; }
    // ağırlık için aktif malzeme yoğunluğu
    const md: any = this.modelleme; const yog = MALZEMELER.find(m => m.ad === md?.aktifMalzemeAd)?.yogunluk ?? MALZEMELER[1].yogunluk;
    this.mass.yogunlukAyarla(yog);
    const r = this.mass.hesaplaModel(md, sahne);   // aktif gövde (yoksa sahne)
    if (!r || r.ucgenSayisi === 0) { this.hata = 'Önce bir model oluşturun'; this.cd.detectChanges(); return; }
    this.alanDm2 = +(r.yuzeyAlani.cm2 / 100).toFixed(2);   // cm² → dm²
    this.agirlikKg = +r.agirlik.kg.toFixed(3);
    baglamYaz({ alanDm2: this.alanDm2, netKg: this.agirlikKg, hacimCm3: r.hacim.cm3 });
    this.hata = null; this.hesapla();
  }

  f(v: number, d = 2): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
